export default "__VITE_ASSET__DwT2H$hk__"